import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LanguageText} from '../models/language-text';
import {
  LanguageIdUpdateAction,
  languageTextsActionTypes,
  LoadGlobalLanguageTextSuccessAction,
  LoadLanguageTextSuccessAction,
  LoadReplacementLanguageTextSuccessAction
} from '../actions/language-texts-load';
import {languageTextsUpdateActionTypes} from '../actions/language-text-update';

export interface LanguageTextsState {
  fee: LanguageText[];
  global: LanguageText[];
  replacement: LanguageText[];
  languageId: number;
}

const initialState: LanguageTextsState = {
  fee: undefined,
  global: undefined,
  replacement: undefined,
  languageId: undefined,
};

export function LanguageTextsReducer(state: LanguageTextsState = initialState, action: Action): LanguageTextsState {
  switch (action.type) {
    case languageTextsActionTypes.LOAD_FEE_SUCCESS:
      return handleLoadFeeSuccessAction(state, action);
    case languageTextsActionTypes.LOAD_GLOBAL_SUCCESS:
      return handleLoadGlobalSuccessAction(state, action);
    case languageTextsActionTypes.LOAD_REPLACEMENT_SUCCESS:
      return handleLoadReplacementSuccessAction(state, action);
    case languageTextsActionTypes.LANGUAGE_UPDATE:
      return handleLanguageUpdateSuccessAction(state, action);
    case languageTextsActionTypes.LANGUAGE_CLEAR:
      return handleLanguageClearSuccessAction(state, action);
    case languageTextsActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case languageTextsActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}
function handleLanguageUpdateSuccessAction(state: LanguageTextsState, action: LanguageIdUpdateAction): LanguageTextsState {
  const newState: LanguageTextsState = {
    fee: state.fee,
    global: state.global,
    replacement: state.replacement,
    languageId: action.payload
  };
  return newState;
}
function handleLanguageClearSuccessAction(state: LanguageTextsState, action: LanguageIdUpdateAction): LanguageTextsState {
  const newState: LanguageTextsState = {
    fee: state.fee,
    global: state.global,
    replacement: state.replacement,
    languageId: undefined
  };
  return newState;
}
function handleLoadFeeSuccessAction(state: LanguageTextsState, action: LoadLanguageTextSuccessAction): LanguageTextsState {
  const newState: LanguageTextsState = {
    fee: action.payload,
    global: state.global,
    replacement: state.replacement,
    languageId: state.languageId
  };
  return newState;
}
function handleLoadGlobalSuccessAction(state: LanguageTextsState, action: LoadGlobalLanguageTextSuccessAction): LanguageTextsState {
  const newState: LanguageTextsState = {
    fee: state.fee,
    global: action.payload,
    replacement: state.replacement,
    languageId: state.languageId
  };
  return newState;
}
function handleLoadReplacementSuccessAction(state: LanguageTextsState, action: LoadReplacementLanguageTextSuccessAction): LanguageTextsState {
  const newState: LanguageTextsState = {
    fee: state.fee,
    global: state.global,
    replacement: action.payload,
    languageId: state.languageId
  };
  return newState;
}
function handleLoadClearActions(): LanguageTextsState {
  return initialState
}

function handleLoadErrorActions(state: LanguageTextsState): LanguageTextsState {
  return state;
}

export const languageTextsSelectors = {
  fee: (state: LanguageTextsState) => _.get(state, 'fee', null),
  global: (state: LanguageTextsState) => _.get(state, 'global', null),
  replacement: (state: LanguageTextsState) => _.get(state, 'replacement', null),
  languageId: (state: LanguageTextsState) => _.get(state, 'languageId', null)
};


